<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>

  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">identifier</th>
                <th class="table-heading-text text-right">valuation</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="collectible in collectibles.collectibles" :key="collectible.id" @click="showEditModal(collectible)">
                <td class="table-content-text text-left"> {{ collectible.identifier }}</td>
                <td class="table-content-text text-right">{{ collectible.valuation.toLocaleString() }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td class="table-heading-text text-right">{{ Number(collectibles.total_valuation).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- Modals-->
  <CollectibleModalPopup :show="showModal" @close="showModal = false"></CollectibleModalPopup> <!-- add a new record -->
  <CollectibleEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></CollectibleEditModalPopup> <!--edit a record -->

</template>

<script>
import axios from 'axios';
import CollectibleModalPopup from './modals/CollectibleNewModalPopup.vue';
import CollectibleEditModalPopup from './modals/CollectibleEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    CollectibleModalPopup,
    CollectibleEditModalPopup
  },
  data() {
    return {
      collectibles: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {}
    };
  },
  async created() {
    this.getCollectibles();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'collectible assets',
          disabled: true,
          href: ''
        },
      ];
    },

  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
     this.selectedRow=row;
     this.showEditModalToggle = true;
    },
    async getCollectibles(){
      try {
      const response  = await axios.get("/collectibles/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.collectibles = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load collectibles' });
      }
    }
  }
};
</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}


</style>
